import script from "./AdministratorProjectFormStep10.vue?vue&type=script&setup=true&lang=js"
export * from "./AdministratorProjectFormStep10.vue?vue&type=script&setup=true&lang=js"

import "./AdministratorProjectFormStep10.vue?vue&type=style&index=0&id=5f5bac1a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f5bac1a"]])

export default __exports__